import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnimationEase: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAnimationEase"><Path d="M20.5 3.5C5.19787 4.43777 18.8021 19.5622 3.5 20.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconAnimationEase;
